import entities from '../../config';
import {getElementByTagName} from '../utils';

const createMenu = (hash) => {
    const nav = getElementByTagName('nav');

    while (nav.firstChild) {
        nav.removeChild(nav.firstChild);
    }

    const menuFragment = document.createDocumentFragment();
    const ul = document.createElement('ul');

    for (let page of entities) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = generateMenuLink(page.link);
        a.innerText = page.name;

        if (hash === page.link) {
            a.classList.add('active');
        }
        li.append(a);
        ul.append(li);
    }

    menuFragment.append(ul);

    nav.append(menuFragment);
};

const generateMenuLink = (link) => `#${link}`;


export default createMenu;
